<ng-container *ngIf="getError()">
  <img src="./assets/img/alert.svg" alt="Error" />

  <!-- <div class="errors-tooltip">
    {{ getError() }}
  </div> -->
</ng-container>
